import { render, staticRenderFns } from "./TypePayment.vue?vue&type=template&id=0bb640be&"
import script from "./TypePayment.vue?vue&type=script&lang=js&"
export * from "./TypePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports